export const stringIsNullOrEmpty: Function = (str: string): boolean => (!str || 0 === str.length);

export const stringIsNullOrBlank: Function = (str: string): boolean => (!str || !str.trim || 0 === str.trim().length)

export function getPlural(number: number, one: string, two: string, five: string) {
    let n = Math.abs(number);
    n %= 100;
    if (n >= 5 && n <= 20) return five;
    n %= 10;
    if (n === 1) return one;
    if (n >= 2 && n <= 4) return two;
    return five;
}
export class DecimalFormatter {
    public static format(src: number, n, handridSeparator: string, fractionsSeparator: string) {
        if (!src || (!n && n !== 0) || !handridSeparator || !fractionsSeparator) return "0";

        const x = 3;
        const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
            num = (+src).toFixed(Math.max(0, ~~n));
        const res = (fractionsSeparator ? num.replace('.', fractionsSeparator) : num)
            .replace(new RegExp(re, 'g'), '$&' + (handridSeparator || ','));
        return res;
    };
}
